import React, { useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import axios from "../../../../lib/axios";
import { Slide, toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";
import axiosInstance from "../../../../lib/axios";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import { getFormMode } from "../../../../lib/helpers";
import * as z from 'zod';
import { useReactToPrint } from "react-to-print";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";

const FORM_MODE = getFormMode();
const STATUS_ACTIVE = "1";
const STATUS_INACTIVE = "0";

function parseTime(timeStr) {
  const [h, m] = timeStr.split(':').map(Number);
  return h * 60 + m;
}
// const shiftSchema = z.object({
//   ShiftAltCode: z.string().optional(),
//   ShiftAbrv: z.string().optional(),
//   Remark: z.string().optional(),
//   ShiftName: z.string().min(1, "Shift Name is required"),
//   FromTime: z.string().regex(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/, "Invalid From Time format (HH:mm)"),
//   ToTime: z.string().regex(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/, "Invalid To Time format (HH:mm)"),
//   Hours: z.number().gte(0, "Total Hours must be greater than or equal to 0"),
// });
const shiftSchema = z.object({
  ShiftAltCode: z.string().optional(),
  ShiftAbrv: z.string().optional(),
  Remark: z.string().optional(),

  ShiftName: z
    .string()
    .min(1, "Shift Name is required")
    .refine(val => val.trim().length > 0, { message: "Shift Name is required" }),

  FromTime: z
    .string()
    .min(1, "From Time is required")
    .regex(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/, "Invalid From Time format (HH:mm)"),

  ToTime: z
    .string()
    .min(1, "To Time is required")
    .regex(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/, "Invalid To Time format (HH:mm)"),

  Hours: z
    .number()
    .refine(val => val > 0, { message: "Total Hours is required" })
    .refine(val => val <= 24, { message: "Total Hours cannot exceed 24" }),
});

const columns = [
  { id: "RowNum", label: "S.No.", minWidth: 170 },
  { id: "ShiftName", label: "Shift Name", minWidth: 170 },
  { id: "ShiftAltCode", label: "Shift Alt Code", minWidth: 100 },
  { id: "ShiftAbrv", label: "Shift Abrv", minWidth: 170 },
  { id: "FromTime", label: "From Time", minWidth: 100 },
  { id: "ToTime", label: "To Time", minWidth: 170 },
  { id: "TotalHours", label: "Total Hours", minWidth: 100 },
  { id: "Status", label: "Status", minWidth: 100 },
];

const Shift = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    ShiftAltCode: "",
    ShiftName: "",
    ShiftAbrv: "",
    Remark: "",
    Status: STATUS_ACTIVE,
    FromTime: "00:00",
    ToTime: "00:00",
    Hours: 0,
  });

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [currentShiftId, setCurrentShiftId] = useState(() => location?.state?.ShiftId);
  const [mode, setMode] = useState(() => (currentShiftId ? FORM_MODE.read : FORM_MODE.add));
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const [Status, setStatus] = useState(STATUS_ACTIVE);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);

  const ShiftNameRef = useRef(null);
  const ShiftAbrvRef = useRef(null);
  const RemarkRef = useRef(null);
  const FromTimeRef = useRef(null);
  const ToTimeRef = useRef(null);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  useEffect(() => {
    const getRow = async () => {
      try {
        const response = await axiosInstance.post('Shift/GetShiftDashboard',
          {
            SearchText: "",
          });
        const {
          data: { Status, Data },
        } = response;
        if (Status === 0 && Array.isArray(Data)) {
          const formattedData = Data.map((shift) => ({
            ...shift,
            ShiftName: shift.ShiftName || "",
            ShiftAltCode: shift.ShiftAltCode || "",
            ShiftAbrv: shift.ShiftAbrv || "",
            Remark: shift.Remark,
            Status:
              shift.Status === null
                ? ""
                : shift.Status == 1
                  ? "Active"
                  : "Inactive",
            // Format time fields
            FromTime: formatTime(shift.FromTime),
            ToTime: formatTime(shift.ToTime),
            TotalHours: shift.Hours || 0,
          }));
          setRows(formattedData);
          setDataForPrint(formattedData);
          // if (res.data && res.data.Data) {
          //   setRows(res.data.Data);
          //   setDataForPrint(res.data.Data);
        }
        else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
    getRow();
  }, []);

  const calculateHours = (fromTime, toTime) => {
    if (!fromTime || !toTime) return 0;
    const fromParts = fromTime.split(':').map(Number);
    const toParts = toTime.split(':').map(Number);
    if (fromParts.some(isNaN) || toParts.some(isNaN)) return 0;

    const fromDate = new Date();
    const toDate = new Date();
    fromDate.setHours(fromParts[0], fromParts[1], 0, 0);
    toDate.setHours(toParts[0], toParts[1], 0, 0);

    let hours = (toDate - fromDate) / (1000 * 60 * 60);
    if (hours < 0) {
      hours += 24; // Handle night shifts crossing midnight
    }
    return Number(hours.toFixed(2)); 
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? STATUS_ACTIVE : STATUS_INACTIVE;
    setStatus(updatedStatus);
    setFormData((prevData) => ({
      ...prevData,
      Status: updatedStatus,
    }));
  };

  const handlePrevious = async () => {
    if (currentShiftId && currentShiftId > 1) {
      await fetchShiftData(currentShiftId, "P");
    }
  };

  const handleNext = async () => {
    if (currentShiftId) {
      await fetchShiftData(currentShiftId, "N");
    }
  };

  useEffect(() => {
    if (location.state && location.state.ShiftId) {
      setCurrentShiftId(location.state.ShiftId);
      fetchShiftData(location.state.ShiftId);
      setMode(FORM_MODE.read);
    } else {
      setMode(FORM_MODE.add);
      setIsFormDisabled(false);
    }
  }, [location]);

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const fetchShiftData = async (id, flag = "r") => {
    try {
      const response = await axios.post(`Shift/RetriveShift`, {
        ShiftId: parseInt(id),
        Flag: flag,
      });
      const { Status, Data } = response.data;

      if (Status === 0 && Data) {
        setFormData({
          ShiftAltCode: Data.ShiftAltCode || "",
          ShiftName: Data.ShiftName,
          ShiftAbrv: Data.ShiftAbrv,
          Remark: Data.Remark,
          Status: Data.Status,
          FromTime: formatTime(Data.FromTime),
          ToTime: formatTime(Data.ToTime),
          Hours: Data.Hours || 0,
        });
        setStatus(Data.Status.toString());
        setIsFormDisabled(true);
        setCurrentShiftId(Data.ShiftId);
      } else {
        console.error("Failed to fetch shift data");
      }
    } catch (error) {
      console.error("Error fetching shift data:", error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "FromTime" || name === "ToTime") {
      handleTimeInputChange(event);
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleTimeInputChange = (event) => {
    const { name, value } = event.target;
    const sanitizedValue = value.replace(/[^0-9:]/g, '');

    let [hours = '', minutes = ''] = sanitizedValue.split(':');
    hours = hours.slice(0, 2);
    minutes = minutes.slice(0, 2);

    const updateFormData = (formattedTime) => {
      setFormData((prev) => {
        const newData = { ...prev, [name]: formattedTime };
        newData.Hours = calculateHours(newData.FromTime, newData.ToTime);
        return newData;
      });
    };

    if (event.type === 'blur') {
      let finalHours = hours.padStart(2, '0').slice(0, 2);
      let finalMinutes = minutes.padStart(2, '0').slice(0, 2);

      const numericHours = parseInt(finalHours, 10);
      const numericMinutes = parseInt(finalMinutes, 10);

      if (isNaN(numericHours) || isNaN(numericMinutes) || numericHours > 23 || numericMinutes > 59) {
        finalHours = '00';
        finalMinutes = '00';
      }

      const formattedTime = `${finalHours}:${finalMinutes}`;
      updateFormData(formattedTime);
    } else {
      const displayValue = hours + (minutes ? ':' + minutes : '');
      updateFormData(displayValue);
    }
  };

  const handleSubmit = async () => {
    const normalizedData = {
      ShiftAltCode: (formData.ShiftAltCode || "").trim(),
      ShiftName: formData.ShiftName.trim(),
      ShiftAbrv: (formData.ShiftAbrv || "").trim(),
      Remark: (formData.Remark || "").trim(),
      Status: formData.Status,
      FromTime: formData.FromTime.padStart(5, '0').slice(-5).replace(/^(\d):/, '0$1:'),
      ToTime: formData.ToTime.padStart(5, '0').slice(-5).replace(/^(\d):/, '0$1:'),
      Hours: 0,
    };

    normalizedData.Hours = calculateHours(normalizedData.FromTime, normalizedData.ToTime);

    const result = shiftSchema.safeParse(normalizedData);

    if (!result.success) {
      const firstError = result.error.errors[0];
      toast.error(firstError.message); // e.g., "From Time is required"
      return;
    }
    // const result = shiftSchema.safeParse(formData);
    // if (!result.success) {
    //   toast.error("Please fill required details.");
    //   return;
    // }
    const { data } = result;

    try {
      const payload = {
        ShiftKey: "",
        ShiftAltCode: data.ShiftAltCode,
        ShiftName: data.ShiftName,
        ShiftAbrv: data.ShiftAbrv,
        Remark: data.Remark,
        Status: formData.Status,
        FromTime: data.FromTime,
        ToTime: data.ToTime,
        Hours: data.Hours,
      };

      let response;
      if (mode === FORM_MODE.edit) {
        payload.ShiftId = currentShiftId;
        payload.UpdatedBy = parseInt(UserId, 10);
        await UnLock(currentShiftId, "Shift", "ShiftId");
        response = await axios.patch(`Shift/UpdateShift`, payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post(`Shift/InsertShift`, payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message, { autoClose: 1000 });
        if (mode === FORM_MODE.add) {
          setCurrentShiftId(response.data.Data);
          await fetchShiftData(response.data.Data);
          setMode(FORM_MODE.read);
          setIsFormDisabled(true);
        } else {
          setMode(FORM_MODE.read);
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error saving/updating shift:", error);
    }
  };

  const handleEdit = async () => {
    setMode(FORM_MODE.edit);
    setIsFormDisabled(false);
  };

  const handleAdd = () => {
    setMode(FORM_MODE.add);
    setIsFormDisabled(false);
    setFormData({
      ShiftAltCode: "",
      ShiftName: "",
      ShiftAbrv: "",
      Remark: "",
      Status: STATUS_ACTIVE,
      FromTime: "00:00",
      ToTime: "00:00",
      Hours: 0,
    });
    setCurrentShiftId(null);
    setTimeout(() => {
      ShiftNameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    if (mode === FORM_MODE.add) {
      await fetchShiftData(1, "L");
    } else {
      // await UnLock(currentShiftId, "Shift", "ShiftId");
      await fetchShiftData(currentShiftId, "R");
    }
    setMode(FORM_MODE.read);
    setIsFormDisabled(true);
  };

  const handleExit = () => {
    navigate("/masters/shift-table");
  };

  const handleDelete = async () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      await fetchShiftData(currentShiftId, "D");
      const response = await axiosInstance.post(`Shift/RetriveShift`, {
        ShiftId: currentShiftId,
        Flag: "D",
      });
      if (response instanceof Error) {
        return console.error("Error Could not delete Shift");
      }
      const { Status, Message, Data } = response.data;
      if (Status === 0) {
        toast.success(Message, { autoClose: 500 });
        await fetchShiftData(currentShiftId, "N");
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 500 });
        } else {
          toast.error(Message, { autoClose: 500 });
        }
      }
      setIsFormDisabled(true);
    } catch (error) {
      console.error("Error deleting shift:", error);
    }
  };

  const handleKeyPress = (event, nextRef) => {
    if (event.key === "Enter" && nextRef) {
      event.preventDefault();
      nextRef.current.focus();
    }
  };

  return (
    <>
      <Box className="form-container"
        sx={{
          width: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          maxWidth: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          height: { xs: "91.5vh", sm: "93.5vh", md: "auto", lg: "92vh" },
          overflowX: "hidden",
          overflowY: { xs: "auto", sm: "hidden", md: "hidden" },
        }}>
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Slide}
        />
        <Grid container spacing={2} className="form_grid"
          sx={{
            width: { xs: "93%", sm: "80%", md: "80%" },
            height: { xs: "650px", sm: "auto", md: "auto" },
            margin: "auto",
            marginTop: { xs: "10px", sm: 0, md: "auto" },
            marginBottom: { xs: "110px", sm: 0, md: "auto" },
            borderRadius: "8px",
            padding: { xs: "0px 5px 5px 5px", sm: "0px 20px 20px 20px" },
            backgroundColor: "#fff",
          }}>
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: "block",
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={
                  mode !== FORM_MODE.read || !currentShiftId || currentShiftId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  display: "block",
                }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={mode !== FORM_MODE.read || !currentShiftId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Shift Master
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Shift Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onView={handlePrint}
                onExit={handleExit}
                readOnlyMode={mode === FORM_MODE.read}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            className="form_field"
          //    sx={{ marginInline: { xs: "10px", sm: "80px" } }}
          >
            <Grid container spacing={2} >
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="ShiftName"
                  name="ShiftName"
                  label={
                    <span>
                      Shift Name <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.ShiftName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={ShiftNameRef}
                  onKeyDown={(event) => handleKeyPress(event, ShiftAbrvRef)}

                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="ShiftAltCode"
                  name="ShiftAltCode"
                  label={"Shift Code"}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.ShiftAltCode}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="ShiftAbrv"
                  name="ShiftAbrv"
                  label="Shift Abrv"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.ShiftAbrv}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={ShiftAbrvRef}
                  onKeyDown={(event) => handleKeyPress(event, FromTimeRef)}
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <div style={{ overflow: "auto", maxHeight: "56px" }}>
                  <TextField
                    id="FromTime"
                    name="FromTime"
                    label={
                      <span>
                        From Time <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    value={formData.FromTime}
                    onChange={handleInputChange}
                    onBlur={handleTimeInputChange}
                    disabled={isFormDisabled}
                    inputRef={FromTimeRef}
                    onKeyDown={(event) => handleKeyPress(event, ToTimeRef)}

                  />
                </div>
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <div style={{ overflow: "auto", maxHeight: "56px" }}>
                  <TextField
                    id="ToTime"
                    name="ToTime"
                    label={
                      <span>
                        To Time <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    value={formData.ToTime}
                    onChange={handleInputChange}
                    onBlur={handleTimeInputChange}
                    disabled={isFormDisabled}
                    inputRef={ToTimeRef}
                    onKeyDown={(event) => handleKeyPress(event, RemarkRef)}

                  />
                </div>
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <TextField
                  id="Hours"
                  name="Hours"
                  label={
                    <span>
                      Total Hours <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Hours}
                  InputProps={{
                    readOnly: true,
                  }}

                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label="Remark"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={RemarkRef}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={mode === FORM_MODE.read}
                        checked={Status === STATUS_ACTIVE}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === FORM_MODE.read && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>
      <div style={{ display: "none" }}>
        {rows.length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows.map(row => ({
              ...row,
              Status: row.Status === "1" ? "Active" : row.Status === "0" ? "Inactive" : row.Status,
            }))}
            title="Shift Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Shift;